import firebase from "firebase/compat/app";
import "firebase/compat/auth";

const ERROR_SESION = "errorSesion";

// Cierra la sesión solo en el CRM (sin pasar por el portal). Se borra también
// el csrfToken porque AuthGuard y LoginPage lo usan para decidir si reautenticar:
// si queda guardado sin sesión de Firebase la app se queda en la pantalla de
// carga. El motivo se muestra en el login en vez de redirigir solo al portal,
// para no entrar en un bucle CRM <-> portal cuando el backend rechaza al usuario.
export const cerrarSesionLocal = (motivo) => {
  localStorage.setItem("csrfToken", "");
  if (motivo) {
    sessionStorage.setItem(ERROR_SESION, motivo);
  }
  return firebase.auth().signOut();
};

export const getErrorSesion = () => sessionStorage.getItem(ERROR_SESION);

export const limpiarErrorSesion = () => sessionStorage.removeItem(ERROR_SESION);
